import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { withLang } from '../utils/i18nRoutes'

const SITE_URL = 'https://tartis.io'
const SITE_NAME = 'TARTIS'

const Seo = ({ title, description, path = '/', serviceName }) => {
  const { i18n } = useTranslation()
  const lang = i18n.language === 'en' ? 'en' : 'es'
  const url = `${SITE_URL}${withLang(path, lang)}`
  const fullTitle = title ? `${SITE_NAME} · ${title}` : SITE_NAME

  const serviceSchema = serviceName && {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: serviceName,
    description,
    url,
    inLanguage: lang,
    provider: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
    },
  }

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="es" href={`${SITE_URL}${path}`} />
      <link
        rel="alternate"
        hrefLang="en"
        href={`${SITE_URL}${withLang(path, 'en')}`}
      />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={lang === 'en' ? 'en_US' : 'es_ES'} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {serviceSchema && (
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
      )}
    </Helmet>
  )
}

export default Seo
